import icone from '../../assets/images/Rectangle.png';
import icone2 from '../../assets/images/Icon.png';
import infoIcon from '../../assets/images/info.png';
import heartIcon from '../../assets/images/coeur.png';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Doctors from './doctors';

const DoctorDashboard = () => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [departments, setDepartments] = useState([]);
    const popoverRefs = useRef([]);

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);
  
    // Fetch appointments
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

                // Create a request for each hospitalId
                const promises = hospitalIds.map(hospitalId =>
                    api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                );

                const responses = await Promise.all(promises);

                // Combine all responses
                const allAppointments = responses.flatMap(response => response.data);

                // Filter appointments with paymentStatus true
                const appointmentsWithPaymentStatus = allAppointments.filter(appointment => appointment.paymentStatus === true);

                // Add vital sign check for each appointment
                const appointmentsWithSignVitalStatus = await Promise.all(
                    appointmentsWithPaymentStatus.map(async (appointment) => {
                        const signVitalExists = await fetchSignVitalStatus(appointment._id);
                        return {
                            ...appointment,
                            signVitalExists,
                        };
                    })
                );

                setAppointments(appointmentsWithSignVitalStatus);

            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // Function to check if vital signs exist for an appointment
    const fetchSignVitalStatus = async (appointmentId) => {
        try {
            const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
            return response.data.signVitaldata;
        } catch (error) {
            console.error('Error checking vital signs:', error);
            return false;
        }
    };

    // Fetch departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartments();
    }, []);

    // Initialize popovers
    useEffect(() => {
        popoverRefs.current.forEach((popoverEl) => {
            if (popoverEl && window.bootstrap) {
                new window.bootstrap.Popover(popoverEl, {
                    html: true,
                    trigger: 'click',
                });
            }
        });
    }, [appointments]);

    const handleViewHistory = () => {
        navigate("/hospitaladmin/appointment_history");
    };

    const handleViewHistory2 = () => {
        navigate("/hospitaladmin/patient_details");
    };

    const handleviewcalendar = (doctorId) => {
        navigate(`/hospitaladmin/doctor/calendar/${doctorId}`);
    };

    const doctorId = UserData._id;

    return (
        <div className='enrol'>
           <Doctors doctor={UserData._id}/>
        </div>
    );
};

export default DoctorDashboard;